var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPluralBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.8062 61.9967C59.8062 31.0843 59.8062 5.62442 59.8062 2.28585C59.8062 2.09021 59.6283 1.95546 59.4414 2.01365C49.7248 5.03836 42.2998 38.7108 42.2998 61.9967C42.2998 85.3049 48.9951 119.019 59.4439 121.988C59.6303 122.041 59.8062 121.907 59.8062 121.713C59.8062 118.396 59.8062 92.9257 59.8062 61.9967Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0035 61.2277C38.0035 29.808 48.9224 6.06699 50.0824 3.63334C50.131 3.53153 50.0553 3.42773 49.9426 3.43337C39.7983 3.94048 21.2583 36.3272 21.2583 61.2277C21.2583 86.1212 39.7881 119.993 49.9342 120.542C50.0489 120.548 50.1228 120.437 50.0707 120.334C48.8508 117.94 38.0035 95.6805 38.0035 61.2277Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2224 61.244C17.2224 30.3611 35.0244 10.8494 37.4916 8.29351C37.59 8.19152 37.5124 8.02858 37.3716 8.04527C26.4993 9.3334 2 31.9505 2 61.244C2 90.5621 23.5663 112.45 37.2958 115.889C37.4417 115.926 37.5497 115.76 37.4493 115.648C34.8283 112.726 17.2224 91.9564 17.2224 61.244Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1513 61.9967C64.1513 31.0843 64.1513 5.62443 64.1513 2.28585C64.1513 2.09021 64.3292 1.95547 64.5161 2.01366C74.2327 5.03837 81.6577 38.7108 81.6577 61.9967C81.6577 85.3049 74.9624 119.019 64.5137 121.988C64.3272 122.041 64.1513 121.907 64.1513 121.713C64.1513 118.396 64.1513 92.9257 64.1513 61.9967Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8277 61.2277C85.8277 29.808 74.9089 6.06699 73.7488 3.63334C73.7003 3.53153 73.7759 3.42773 73.8886 3.43337C84.0329 3.94048 102.573 36.3272 102.573 61.2277C102.573 86.1212 84.0431 119.993 73.897 120.542C73.7823 120.548 73.7084 120.437 73.7605 120.334C74.9804 117.94 85.8277 95.6805 85.8277 61.2277Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.778 61.244C106.778 30.3611 88.9756 10.8494 86.5084 8.29351C86.41 8.19152 86.4876 8.02858 86.6284 8.04527C97.5007 9.3334 122 31.9505 122 61.244C122 90.5621 100.434 112.45 86.7042 115.889C86.5583 115.926 86.4503 115.76 86.5507 115.648C89.1717 112.726 106.778 91.9564 106.778 61.244Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluralBulb);
export default __webpack_public_path__ + "static/media/plural-bulb.67bdab05a930afc1179ea21e601a1f56.svg";
export { ForwardRef as ReactComponent };